module.exports = __webpack_public_path__ + "assets/img/ic-export-blue.aa805d09.svg";